module.exports = __webpack_public_path__ + "img/switch.light.39df3d12.svg";